/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import { Auth, I18n, Logger } from 'aws-amplify';
import React from 'react';
import { ButtonRow, FormSection, InputRow, Link, SectionBody, SectionFooter, SectionHeader } from '../AmplifyUI';
import AuthPiece from './AuthPiece';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const logger = new Logger('ConfirmSignIn');

export default class ConfirmSignIn extends AuthPiece {
    constructor(props) {
        super(props);

        this._validAuthStates = ['confirmSignIn'];
        this.confirm = this.confirm.bind(this);
        this.state = {
            mfaType: 'SMS'
        }
    }

    confirm() {
        const user = this.props.authData;
        const { code } = this.inputs;
        const mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null;
        Auth.confirmSignIn(user, code, mfaType)
            .then(() => this.changeState('signedIn'))
            .catch(err => this.error(err));
    }

    componentDidUpdate() {
        //logger.debug('component did update with props', this.props);
        const user = this.props.authData;
        const mfaType = user && user.challengeName === 'SOFTWARE_TOKEN_MFA' ?
            'TOTP' : 'SMS';
        if (this.state.mfaType !== mfaType) this.setState({ mfaType });
    }

    showComponent(theme) {
        const { hide, authData } = this.props;
        if (hide && hide.includes(ConfirmSignIn)) { return null; }

        return (
            <div className="login-content text-center" >
                <div className="logo">
                    <img src="/nhra-logo.jpg" />
                </div>
                <div className="logo-text">NATIONAL HEALTH REGULATORY AUTHORITY</div>
                <div className="mt-3">
                    <Typography gutterBottom variant="headline" component="h2">
                        {I18n.get('Confirm ' + this.state.mfaType + ' Code')}
                    </Typography>

                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <InputRow
                                autoFocus
                                placeholder={I18n.get('Code')}
                                theme={theme}
                                key="code"
                                name="code"
                                onChange={this.handleInputChange} />
                        </Grid>
                    </Grid>

                    <SectionBody>
                        <ButtonRow
                            theme={theme}
                            onClick={this.confirm}>
                            {I18n.get('Confirm')}
                        </ButtonRow>
                    </SectionBody>

                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <hr/>
                            <Button
                                color="secondary"
                                onClick={() => this.changeState('signIn')}>
                                {I18n.get('Back to Sign In')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}
